export default __webpack_public_path__ + "static/media/xoBeautyBrows.755f5a69.PNG";